import { useMemo } from 'react';

type LabelField = 'label1' | 'label2' | 'label3' | 'label4' | 'label5';

interface LabelColorMap {
  label1: string;
  label2: string;
  label3: string;
  label4: string;
  label5: string;
}

const useLabelColor = () => {
  const colorMap: LabelColorMap = useMemo(() => ({
    label1: '#f50',     // red-orange
    label2: '#2db7f5',  // blue
    label3: '#87d068',  // green
    label4: '#108ee9',  // dark blue
    label5: '#bd5bff',  // purple
  }), []);

  const getLabelColor = (field: LabelField): string => {
    return colorMap[field] || '#000';
  };

  return {
    colorMap,
    getLabelColor
  };
};

export default useLabelColor;